<!--
    描述：专家费用发放记录
    日期：2022/9/19
    创建人：李家宝
-->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="专 家 费 用 " name="1">
        <div style="padding: 0 10px" v-if="rowData.length > 0">
          <el-table
            class="mt10"
            highlight-current-row
            row-key="id"
            border
            ref="table"
            :data="rowData"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="80"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="sname"
              align="center"
              label="姓名"
              min-width="130"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="randomCode"
              align="center"
              label="专家随机码"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{scope.row.randomCode == "" ? "--" : scope.row.randomCode}}
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="手机号"
              min-width="130"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="sex"
              align="center"
              label="性别"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.sex == 0 ? "女" : "男" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ruleName"
              align="center"
              label="抽取条件"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="isGrant"
              align="center"
              label="是否发放专家费"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.isGrant ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fee"
              align="center"
              label="费用（元）"
              min-width="130"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="tenantName"
              align="center"
              label="支付单位"
              min-width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.isGrant ? scope.row.tenantName : "--" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="granter"
              align="center"
              label="操作人"
              min-width="130"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="grantTime"
              align="center"
              label="操作时间"
              min-width="130"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>
        <el-empty description="暂 无 数 据" v-else></el-empty>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "expense-release-record",
  props: {
    rowData: {
      type: Array
    }
  },
  data() {
    return {
      activeNames: ["1"]
    };
  },
  methods: {},

  created() {},

  mounted() {}
};
</script>

<style scoped>
/deep/ .el-collapse-item__header {
  background: #eff6fe;
  font-weight: bolder;
  padding-left: 10px;
}
</style>
